module.exports = require("../../solidity/artifacts/src/solidity/contracts/ERC20Token.sol/ERC20Token.json");